export default __webpack_public_path__ + "img/fACthEfg.a23e2ee6.svg";